// Vendors
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
// Contexts
import { useContractContextConsumerHook } from 'containers/contract/contexts/contract.context';
import { useLayoutContextConsumerHook } from 'components/layout/contexts/layout.context';
// Handlers
import { IbanSelectorHandlers } from '../handlers/iban-selector.handlers';
// Types
import { ContractIbanSelectorHookType } from './types/iban-selector.hook.type';
// Utils
import { ibanHasChanged } from '../utils/iban-selector.utils';

const useContractIbanSelectorHook = (): ContractIbanSelectorHookType => {
  const { formatMessage } = useIntl();
  const { flowApiData } = useLayoutContextConsumerHook();

  const { fetchingSave, ibanList, setIbanList, setSelectedIban } = useContractContextConsumerHook();

  const { handleChangeIban, handleSetupIbanList } = IbanSelectorHandlers({
    flowApiData,
    setIbanList,
    setSelectedIban,
  });

  useEffect(() => {
    handleSetupIbanList();
  }, []);

  return {
    fetchingSave,
    formatMessage,
    handleChangeIban,
    ibanList,
    disableSave: !ibanHasChanged({ oldIbanList: flowApiData?.accounts, ibanList }),
  };
};

export { useContractIbanSelectorHook };
